export enum ReminderDays {
    Four_Weeks = 28,
    One_Month=30,
    Three_Months=90,
    Six_Months=180,
    Year=365,
    Three_Years=1095
}
